import {inject, Injectable, NgZone} from "@angular/core";
import {CommunicationHandlerService} from "@cbcore/services/utils/communication-handler/communication-handler.service";
import {distinctUntilChanged, filter} from "rxjs/operators";
import {SentryService} from "@cbcore/services/sentry/sentry.service";

export let ORIGIN = "https://play.midolotto.com";

export const setOriginFromUrl = ()  => {
  const params: any = {};
  const separated = window.location.search.includes('?') ? window.location.search.split('?')[1] : window.location.search;
  separated.split('&').forEach((param) => {
    const [key, value] = param.split('=');
    params[key] = value;
  });

  console.log('queryparams: ', params);

  switch (params.env) {
  case 'CB_LOCAL':
    ORIGIN = 'http://local.nebula.stg-cbus.com:8000';
    break;
  case 'LOCAL':
    ORIGIN = 'http://localhost:3000';
    break;
  case 'DEV':
    ORIGIN = 'https://dev-play.midolotto.com';
    break;
  case 'STAGING':
    ORIGIN = 'https://staging-play.midolotto.com';
    break;
  case 'SANDBOX':
    ORIGIN = 'https://sandbox-play.midolotto.com';
    break;
  case 'PROD':
    ORIGIN = 'https://play.midolotto.com';
    break;
  default:
    ORIGIN = 'https://play.midolotto.com';
    break;
  }
}

setOriginFromUrl();

const sendMessageToApp = (message: string)=> {
  // iOS Case to send messages
  if (
    (window as any).webkit &&
    (window as any).webkit.messageHandlers &&
    (window as any).webkit.messageHandlers.callbackHandler
  ) {
    (window as any).webkit.messageHandlers.callbackHandler.postMessage(message, ORIGIN);
    return;
  }
  // PWA Case to send messages
  if (window.parent && typeof window.parent.postMessage == "function") {
    window.parent.postMessage(message, ORIGIN);
  }
}

@Injectable()
export class ExtendedCommunicationHandler extends CommunicationHandlerService {
  private sentry = inject(SentryService);
  constructor(private ngZone: NgZone) {
    super();

    this.events$.pipe(
      filter(event => {
        return event !== null;
      }),
      distinctUntilChanged(),
    ).subscribe(events => {
      this.handleExtendedEvents(events);
    });
  }

  protected handleResponse(response: any): void {
    if (response.type === 'ERROR_HANDLED') {
      console.error('Error was handled:', response);
    }
    super.handleResponse(response);
  }

  clearError(message?: string): void {
    this.emitEvent({ type: message || 'ERROR_CLEARED' });
  }

  protected handleExtendedEvents(events: any): void {
    try {
      if (events?.payload?.message === 'process_geo_validation') {
        sendMessageToApp(events.payload.message);
      }
      if (events?.payload?.message === 'ERR_MAXIMUM_DAILY_AMOUNT_EXCEEDED') {
        sendMessageToApp(events.payload.message);
      }
      if (events?.payload?.message === 'ERR_MAXIMUM_WEEKLY_AMOUNT_EXCEEDED') {
        sendMessageToApp(events.payload.message);
      }
      if (events?.payload?.message === 'ERR_MAXIMUM_MONTHLY_AMOUNT_EXCEEDED') {
        sendMessageToApp(events.payload.message);
      }
    } catch (error) {
      this.sentry.logError('handleExtendedEvents() fn', {
        error: error,
      });
    }
  }

  public receiveMessages(message: string | undefined) {
    if (message) {
      if (message === 'geo_validation_success') {
        this.clearError('geo_validation_success');
      }
    }
  }
}
